"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOURCE_CREATE_ERROR = exports.PRESENTER_JOIN_FAILURE = void 0;
var SOURCE_CREATE_ERROR = exports.SOURCE_CREATE_ERROR = 'Source creation failed';
var PRESENTER_JOIN_FAILURE = exports.PRESENTER_JOIN_FAILURE = 'failed to join!';